import React from 'lib/react';
import {
  EVGrid, EVButton,
  makeStyles,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useDispatch, useSelector } from 'lib/redux';
import { saveOrderPreferences } from 'features/orderPreferences/OrderPreferences.actions';
import { cancelOrderPreferencesChanges } from '../OrderPreferences.actions';

const useStyles = makeStyles((theme) => ({
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '15px',
    padding: '24px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  saveButton: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
  cancelButton: {
    padding: '10px 16px',
    borderColor: theme.evPalette.salt[100],
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
}));

function SaveAndCancelButtons() {
  const classes = useStyles();
  const { t } = useTranslation();

  const saveLoading = useSelector(({ orderPreference }) => orderPreference.saveLoading);

  const dispatch = useDispatch();

  const handleSaveChanges = () => dispatch(saveOrderPreferences());

  const handleCancelChanges = () => dispatch(cancelOrderPreferencesChanges());

  return (
    <EVGrid className={classes.buttonsContainer}>
      <EVButton
        id="save-btn"
        variant="contained"
        className={classes.saveButton}
        color="primary"
        type="submit"
        onClick={handleSaveChanges}
        loading={saveLoading}
      >
        {t('common__save')}
      </EVButton>
      <EVButton
        id="cancel-btn"
        color="primary"
        variant="outlined"
        className={classes.cancelButton}
        onClick={handleCancelChanges}
      >
        {t('common_cancel')}
      </EVButton>
    </EVGrid>
  );
}

export default SaveAndCancelButtons;
